import { render, staticRenderFns } from "./UserOpinionResult.vue?vue&type=template&id=550e1d24&scoped=true&"
import script from "./UserOpinionResult.vue?vue&type=script&lang=js&"
export * from "./UserOpinionResult.vue?vue&type=script&lang=js&"
import style0 from "./UserOpinionResult.vue?vue&type=style&index=0&id=550e1d24&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550e1d24",
  null
  
)

export default component.exports